import { FC } from 'react';
import { SidebarBase } from '../common';
import { SIDEBAR_CONFIG } from '../common/constants';

type SidebarNavigationProps = {
  className?: string;
};

export const SidebarNavigation: FC<SidebarNavigationProps> = ({ className }) => {
  return (
    <SidebarBase.Navigation className={className}>
      <div className='grow'>
        {SIDEBAR_CONFIG.map((item) => (
          <SidebarBase.NavItem
            key={item.path}
            {...item}
            classNames={{
              text: 'text-secondary-700',
            }}
          />
        ))}
      </div>
      <SidebarBase.SettingsItem />
      <SidebarBase.SupportItem />
    </SidebarBase.Navigation>
  );
};
